import { render, staticRenderFns } from "./BookingCustomer.vue?vue&type=template&id=31dee07d&scoped=true"
import script from "./BookingCustomer.vue?vue&type=script&lang=js"
export * from "./BookingCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dee07d",
  null
  
)

export default component.exports